import { useMutation, useQueryClient } from '@tanstack/react-query';
import { authAPI } from '../api/authAPI';
import { ISignIn } from '../types/Auth';

import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../../../store/slices/userSlice';
import { userInfo } from '../../../store/selectors/user';
import { captureApiError } from '../../../lib/sentry-utils';
import { syncGuestAddressToBackend } from '../../addresses/services/syncGuestAddress';
import { resetAccountQueries } from '../libs/session';

export const useSingIn = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const user = useSelector(userInfo);
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (body: ISignIn) => {
      const res = await authAPI.signIn(body);

      if (res.data.success) {
        localStorage.setItem('token', res.data.token);
        // Вход через Telegram — тоже смена аккаунта: данные прошлого из кэша.
        resetAccountQueries(queryClient);
      }
    },
    onSuccess: () => {
      if (localStorage.getItem('token')) {
        dispatch(
          setAuth({
            ...user,
            isAuth: true,
          })
        );
        syncGuestAddressToBackend(queryClient);
      }
    },
    onError: error => {
      console.error('SignIn error:', JSON.stringify(error, Object.getOwnPropertyNames(error), 2));
      captureApiError(error, '/api/auth/sign-in', 'POST');
    },
  });
  return {
    signIn: mutateAsync,
    isPending,
  };
};
